module.exports = __webpack_public_path__ + "img/14.6.CODm.9ec5df34.png";